<template>
  <el-config-provider :locale="store.getters.locale">
    <Suspense>
      <template #default>
        <el-watermark :gap="[600,300]" :offset="[340, 170]" :font="{color: 'rgba(224,224,224, 0.3)'}" class="w100 h100" :content="watermark">
          <router-view />
        </el-watermark>
      </template>
      <template #fallback>
        <div class="loading-container flex abs" style="width:100%;height:100%">
          <Loading></Loading>
        </div>
      </template>
    </Suspense>
    <div class="flex" v-if="error" style="width:100%;height:100%">
      <ErrorComp :error="error" />
    </div>
    <el-dialog top="0vh" custom-class="dialog" v-model="store.state.dialogVisible" :title="store.state.dialogTitle"
      :width="store.state.dialogWidth" :close-on-click-modal="false" destroy-on-close>
      <component @close="store.state.dialogVisible = false" :is="store.state.dialogComponent"
        :data="store.state.dialogPayload.data" :action="store.state.dialogPayload.action"
        :payload="store.state.dialogPayload"></component>
    </el-dialog>
    <el-dialog top="0vh" custom-class="dialog" v-model="dialogVisible" :title="dialogTitle" width="560px"
      :close-on-click-modal="false" destroy-on-close>
      <PublicForm v-model="form" :fields="fields"></PublicForm>
      <div class="footer">
        <div class="right-btns">
          <el-button @click="handleCancel"> {{ $t('common.cancel') }}</el-button>
          <el-button @click="handleConfirm" :loading="loading" type="primary">{{ $t('common.confirm') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </el-config-provider>
</template>

<script lang="ts" setup>
import { onErrorCaptured, reactive, Ref, ref, toRaw } from 'vue'
import * as vue from 'vue'
import i18n from '@/i18n'
import ErrorComp from '@/components/Common/Error.vue'
import Loading from '@/components/Common/Loading.vue'
import PublicForm from '@/components/Form/PublicForm.vue'
import { useStore } from '@/store'
import { EventType } from './constants/event';
import { $app } from './instance';
import { Field } from './types'
import * as utils from './utils/utils'
import { useRouter } from 'vue-router'
import { trackIdentify, track } from '@/utils/analytics'
import { useAnalytics } from '@/composables/analytics'
import { getErrorMessage } from './utils/bussiness'
import { useUpload } from './composables/upload'

const router = useRouter()
useAnalytics()
console.log(router)

const error: Ref<Error | null> = ref(null)
const dialogVisible = ref(false)
const loading = ref(false)
const dialogTitle = ref('')
const watermark = window.IS_QA? ['演示/测试系统', 'Demo/Test System'] : []
let form: { [key: string]: any } = ref({})
const fields: Ref<Field[]> = ref([])
const { handleUploadFiles, scheduleUpload } = useUpload()

let rejectCallback = (e: Error) => { }
let resolveCallback = () => { }
const handleCancel = () => {
  rejectCallback(new Error('canceled'))
  dialogVisible.value = false
}

const handleConfirm = () => {
  resolveCallback()
  dialogVisible.value = false
}

onErrorCaptured((e: Error) => {
  error.value = new Error(getErrorMessage(e))
  console.log(e)
})
// 页面刷新删除错误
router.beforeEach(() => {
  error.value = null
})
const store = useStore()
console.log(store)
$app.services.openPublicForm = (options: {
  title: string,
  models: Array<Field>,
  form: { [key: string]: any },
  validate?: (form: Object) => Promise<boolean>
}) => {
  return new Promise((resolve, reject) => {
    console.log(options)
    if (dialogVisible.value) {
      return reject(new Error('dialog has openned'))
    }
    rejectCallback = reject
    resolveCallback = async () => {
      try {
        const rawForm = toRaw(form)
        console.log(rawForm)
        if (options.validate) {
          await options.validate(rawForm)
        }
        resolve(rawForm)
      } catch (e) {
        reject(e)
      }
    }

    dialogTitle.value = options.title
    dialogVisible.value = true
    fields.value = options.models
    form.value = options.form
  })
}
$app.services.handleUploadFiles = handleUploadFiles
$app.services.scheduleUpload = scheduleUpload
$app.lib = {
  vue: vue,
  i18n: i18n,
  utils: utils
}
window.$app = $app
$app.on(EventType.CREATED, () => {
  $app.CREATED = true
  const userInfo = localStorage.getItem('m_user_traits')
  if (userInfo) {
    // window.TOKEN = JSON.parse(userInfo).usertoken
    $app.LOGINED = true
    $app.userInfo = JSON.parse(userInfo)
    $app.emit(EventType.LOGINED, JSON.parse(userInfo))
  }
})
$app.on(EventType.LOGINED, () => {
  $app.LOGINED = true
  trackIdentify($app.userInfo.user_code, $app.userInfo)
})
$app.on(EventType.LOGOUTED, () => {
  $app.LOGINED = false
  track('logout', {
    ...$app.userInfo,
    ...store.state
  })
})
$app.emit(EventType.CREATED)
if (window.INITED_CALLBACK) {
  window.INITED_CALLBACK($app)
}
</script>

<style lang="stylus">
#app,
body,
html {
  position: fixed;
  height: 100%;
  width: 100%;
  color: var(--color-text);
  background: var(--color-main);
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 500;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -ms-scroll-chaining: none;
  overscroll-behavior: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.dialog {
  transform: translateY(-50%);
  top: 50%;
  padding: 16px 0;
}

.el-dialog__header {
  padding: 8px 16px !important;
}

.preview-dialog .el-dialog__header {
  padding: 0 !important;
}

.el-dialog__body {
  padding: 0 !important;
}

.el-dropdown-menu__item:not(.is-disabled):focus {
  color: #fff !important;
  border-radius: 3px !important;
}

.el-button:focus,
.el-button:hover {
  color: #fff !important;
}

.el-select .el-select__tags .el-tag--info {
  color: #FFF;
  background: #525252 !important;
}

.el-input__wrapper {
  font-size: 12px !important;
  // height: 30px !important;
  width: 100px !important;
}

.el-tabs__item {
  color: #a1a1a1 !important;
}

.el-check-tag {
  background-color: #3f3f3f !important;
  border: 1px transparent solid !important;
  color: #ffffff !important;
  padding: 4px 9px !important;
  font-size: 12px !important;
  border-radius: 4px !important;
}

.el-check-tag.is-checked {
  border: 1px #3662ec solid !important;
  background-color: #3f3f3f !important;
}

.el-message-box__input {
  padding: 0 12px 0 36px!important;
}

.is-active {
  color: #3662ec !important;
}

.footer {
  padding: 16px 16px 0 16px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.upload-popover {
  padding: 0 0 !important;
}

.el-button--text {
  color: var(--el-text-color-regular) !important;
  font-size: 12px !important;
}
.emphasize {
  font-weight: bold;
  font-size: 16px;
  color: #3662ec;
  margin: 0 2px;
}

.bold {
  color: var(--primary-color)
}
</style>
